/** Named performance marks, readable by the benchmark via `window.__viewerMarks`. */
const marks: Record<string, number> = {};

declare global {
  interface Window {
    __viewerMarks?: Record<string, number>;
  }
}

export function mark(name: string): void {
  if (marks[name] !== undefined) return;
  marks[name] = Math.round(performance.now());
  performance.mark(`viewer:${name}`);
  window.__viewerMarks = marks;
}
